import React from 'react';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import { AppNavBarStandardToolbar } from './AppNavBarStandardToolbar';
import { AppNavBarSmallToolbar } from './AppNavBarSmallToolbar';
import { ActiveDatabaseContext } from '../../../ActiveDatabaseContext/ActiveDatabaseContext';
import { System } from '../../../../Features/Routing/Utils/routerUtils';
import {
  LoginStateContext,
  IDatabase,
} from '../../../../Features/Login/Contexts/LoginStateContext/LoginStateContext';
import { useContext } from 'react';
import { useIsTouchDevice } from '../../../BreakpointContext/BreakpointContextUtils';

interface IProps {
  activeDatabaseName: string | null;
  renderTaskMenuButton: (small?: boolean) => React.ReactNode;
  onUserMenuClick: (event: React.MouseEvent<HTMLElement>) => void;
  currentPath: string;
  showEnhetSelector?: boolean;
  isLoggedIn?: boolean;
  miscMenuAnchor?: HTMLElement;
  miscMenuOpen: boolean;
  openMiscMenu: (event: React.MouseEvent<HTMLElement>) => void;
  closeMiscMenu: () => void;
  toggleRightMenu: () => void;
  directEditMode?: boolean | undefined;
  setHelpDialogOpen: (open: boolean) => void;
  routineKey?: string;
  programLocationHeader: string;
  classes?: any;
}

interface IInnerProps extends IProps {
  databases: IDatabase[];
  activeDatabase: string;
  system: System | null;
  isTouchDevice: boolean;
}

const styles = (theme: Theme) => ({
  toolbarRight: {
    display: 'flex',
    flex: '1 1 0%',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingLeft: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      flex: '0',
      justifySelf: 'flex-end',
      paddingLeft: 0,
    },
  },
});

/**
 * Toolbar till AppNavbar. Alternativ visning ges för små skärmar.
 */
export class AppNavBarToolbarBase extends React.Component<IInnerProps> {
  render() {
    const {
      showEnhetSelector = false,
      activeDatabaseName,
      isLoggedIn = false,
      databases,
    } = this.props;

    const activeDatabase = databases.find(db => db.name === activeDatabaseName);
    return (
      <>
        {!this.props.isTouchDevice && (
          <>
            <AppNavBarStandardToolbar
              activeDatabase={activeDatabase}
              currentPath={this.props.currentPath}
              databases={databases}
              isLoggedIn={isLoggedIn}
              onUserMenuClick={this.props.onUserMenuClick}
              renderTaskMenuButton={this.props.renderTaskMenuButton}
              showEnhetSelector={showEnhetSelector}
            />
          </>
        )}
        {this.props.isTouchDevice && (
          <>
            <AppNavBarSmallToolbar
              activeDatabase={activeDatabase}
              setHelpDialogOpen={this.props.setHelpDialogOpen}
              programLocationHeader={this.props.programLocationHeader}
            />
          </>
        )}
      </>
    );
  }
}

const EnhancedAppNavBarToolbarBase: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { activeDatabase, system } = useContext(ActiveDatabaseContext);
  const loginStateContext = useContext(LoginStateContext);
  const isTouchDevice = useIsTouchDevice();
  return (
    <AppNavBarToolbarBase
      {...props}
      databases={loginStateContext.databases}
      activeDatabase={activeDatabase || ''}
      system={system}
      isTouchDevice={isTouchDevice}
    />
  );
};

export const AppNavBarToolbar = withStyles(
  EnhancedAppNavBarToolbarBase,
  styles
);
